<template>
  <div class="pa-2">
    <v-alert
      dense
      type="warning"
      v-if="mostrarLeyendaCerrada"
    >
      La tienda está cerrada. Podrás ver el catálogo pero no hacer pedidos.
      <span v-if="textoTiendaCerrada">{{ textoTiendaCerrada }}</span>
    </v-alert>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import isOpen from '@/helpers/isOpen.js'
import getNextDate from '@/helpers/getNextDate.js'

export default {
  name: 'TiendaCerradaCard',
  computed: {
    ...mapGetters('App', ['data']),
    /** True si la tienda está abierta según horarios (sin horario = abierta) */
    tiendaAbiertaPorHorario () {
      if (!this.data || !this.data.horarioRegular || !this.data.horarioRegular.dataOriginal) {
        return true
      }
      return isOpen(this.data.horarioRegular.dataOriginal)
    },
    /** True cuando debe mostrarse la leyenda: cerrada por bandera NegocioCerrado o por horario */
    mostrarLeyendaCerrada () {
      if (!this.data) return false
      if (this.data.NegocioCerrado) return true
      return !this.tiendaAbiertaPorHorario
    },
    textoTiendaCerrada () {
      if (!this.data || !this.data.horarioRegular || !this.data.horarioRegular.dataOriginal) {
        return ''
      }
      if (isOpen(this.data.horarioRegular.dataOriginal)) return ''
      const next = getNextDate(this.data.horarioRegular.dataOriginal)
      return next ? ` ${next}` : ''
    }
  }
}
</script>
